import React, {Component} from "react";
import {reduxForm} from "redux-form/immutable";
import ActionButton from "../ActionButton";
import FormError from "./FormError";

class ConfirmForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting, submitLabel, showCancel} = this.props;
    let dynSubmitLabel = submitting ? "Standby..." : submitLabel; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>{this.props.message}</p>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={dynSubmitLabel} onClick={submit} active={!submitting} />
          <ActionButton show={showCancel} label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ConfirmForm"
})(ConfirmForm);

ReduxForm.defaultProps = {
  message: "Confirm message",
  submitLabel: "Submit",
  showCancel: true
}

export default ReduxForm;